module.exports = __webpack_public_path__ + "media/img/event/speakers/Mark-Jeynes-6253cbc7da97dd9515684c07eb6a1aac.jpg";